/**
 * LiveReportDetailsScreen — primary adapter for the live-report detail route (`/r?h=…`).
 *
 * Thin wire: data + view-model + modals composition → DS page + modals.
 */
import { useSelector } from "react-redux"

import { LiveReportDetailsPage, NpsModal, ReferralModal } from "../../../../../../design-system"
import { openCalendly } from "../../../../../../data/utility/Utils"
import { liveReportDetailsViewModel } from "../../../../view-models/parent/LiveReports/liveReportDetailsViewModel"
import { useLiveReportDetailsData } from "./useLiveReportDetailsData"
import { useLiveReportDetailsModals } from "./useLiveReportDetailsModals"

export type LiveReportDetailsScreenProps = {
    route?: { params?: { h?: string } | null } | null
}

export function LiveReportDetailsScreen(props: LiveReportDetailsScreenProps) {
    const hash = props.route?.params?.h ?? null
    const data = useLiveReportDetailsData(hash)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => liveReportDetailsViewModel(state, data.raw))
    const modals = useLiveReportDetailsModals({
        hash,
        userEmail: data.userEmail,
        engagementScore: data.engagementScore,
        isAdminOrTutor: data.isAdminOrTutor,
        preloadedReferralCode: data.preloadedReferralCode,
    })

    return (
        <>
            <LiveReportDetailsPage
                report={vm.report}
                loading={data.loading}
                error={vm.error}
                onRetry={data.retry}
                onClose={modals.close}
                onSamPress={() => openCalendly(vm.studentForCalendly)}
                onScroll={modals.onScroll}
            />
            {modals.nps != null && <NpsModal {...modals.nps} />}
            {modals.referral != null && <ReferralModal {...modals.referral} />}
        </>
    )
}

export default LiveReportDetailsScreen
